import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SafetyDashboardComponent } from '../safety-dashboard/safety-dashboard.component';
import { SafetySidebarComponent } from '../safety-sidebar/safety-sidebar.component';

/**
 * Routes for the Safety section of the workspace: the SMS safety dashboard
 * with the shared safety navigation in the sidebar outlet.
 */
@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: SafetyDashboardComponent
            },
            {
                path: '',
                component: SafetySidebarComponent,
                outlet: 'sidebar'
            }
        ])
    ],
    exports: [RouterModule]
})
export class SafetyRoutingModule {}
